/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// Swap between sticky and fixed header

(function (app) {
    function Header() {
        this.el = document.querySelector('.js-header');
        this.marker = document.querySelector('.js-header-marker');
        this.announcement = document.querySelector('.js-announcement');
        this.mobileDraw = document.querySelector('.mfp-draw');
        this.main = document.querySelector('.main');
        this.sections = this.main.querySelectorAll('.shopify-section');

        this.init = () => {
            if (this.el) {
                this.watchScroll();
                this.addClearHeader();
            }
        }

        this.getOffset = () => this.el.dataset.template == 'home' ? 20 : 0;

        this.watchScroll = () => {
            this.checkPageScroll();
            document.addEventListener('scroll', this.checkPageScroll.bind(this));
        }

        this.announcementHeight = () => {
            if (this.announcement) {
                return this.announcement.getBoundingClientRect().height;
            }
        }

        this.headerHeight = () => this.el.getBoundingClientRect().height;

        this.checkForBanner = () => {
            if (this.sections[0].querySelector('.section').dataset.sectionType == 'banner') return true
        }

        this.checkPageScroll = () => {
            if (window.pageYOffset - this.announcementHeight() - this.getOffset() > this.marker.offsetTop) {
                if (!this.el.classList.contains('header--scroll')) {
                    this.el.classList.add('header--scroll');
                }
                this.removeClearHeader();
                if (this.el.dataset.template == 'home') {
                    this.main.style.paddingTop = 0;

                } else if (this.checkForBanner()) {
                    if (window.matchMedia('(max-width: 981px)').matches) {
                        this.main.style.paddingTop = 0;
                    } else {
                        this.main.style.paddingTop = `${this.headerHeight()}px`;  
                    }
                } else {
                    this.main.style.paddingTop = `${this.headerHeight()}px`;
                }
            } else {
                if (this.el.classList.contains('header--scroll')) {
                    this.el.classList.remove('header--scroll');
                }
                this.addClearHeader();
                this.main.style.paddingTop = 0;
            }
        }

        this.addClearHeader = function() {

            if (window.pageYOffset > this.announcementHeight() + this.getOffset()) return

            if (this.el.dataset.template == 'home' && !document.querySelector('.header--clear')) {
                this.el.classList.add('header--clear');
            }

            if (window.matchMedia('(min-width: 982px)').matches) return
            
            if (this.checkForBanner() || this.el.dataset.template == 'home') {
                this.el.classList.add('header--clear');
            } else {
                this.el.classList.add('header--clear', 'header--clear-white');
            }
        }

        // Remove the 'clear' styles from the header
        this.removeClearHeader = function() {
            if (this.el.dataset.template == 'home') {
                this.el.classList.remove('header--clear');
            } else {
                this.el.classList.remove('header--clear', 'header--clear-white');
            }
        }
    }

    const header = new Header();
    header.init();

    app.Header = Header;
})(window.theme = window.theme || {});

(function (app) {
    function MobileAccordion() {
        this.accordions = document.querySelectorAll('.js-mobile-accordion');
        this.items = document.querySelectorAll('.js-accordion-detail');

        this.init = () => {
            if (this.accordions && window.matchMedia('(max-width: 768px)').matches) {
                this.hideItems();
                this.setUpAccordion();
            }
        }

        this.hideItems = () => {
            this.items.forEach(item => item.style.display = 'none');
        }

        this.setUpAccordion = () => {
            for (let i = 0; i < this.accordions.length; i++) {
                this.accordions[i].addEventListener('click', function() {

                    const panel = this.nextElementSibling;

                    if (this.classList.contains('js-active')) {
                        $(panel).slideUp();
                        $(this).attr('aria-expanded', 'false');
                    } else {
                        $(panel).slideDown();
                        $(this).attr('aria-expanded', 'true');
                    }

                    this.classList.toggle('js-active');
                });
            } 
        }
    }
       
    const mobileAccordion = new MobileAccordion();
    mobileAccordion.init();

    app.MobileAccordion = MobileAccordion;
})(window.theme = window.theme || {});

// ===========================
// Columns carousel logic
// ===========================

theme.columnsCarouselUpdate = function(carouselElement) {
	//get sizes
	winWidth = $(window).width();

	var $carousel = $(carouselElement);

	mobile = $carousel.data("carouselMobile");

	$carousel.removeClass('home-columns-carousel--loading');

	function initCarousel($carouselElement) {

		$carouselElement.not(".slick-initialized").slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: true,
			fade: false,
			adaptiveHeight: false,
			speed: 300,
			cssEase: "ease",
			lazyLoad: "progressive",
			prevArrow:
			'<div class="home-columns-carousel__nav home-columns-carousel__nav--prev"><i class="icon icon--left-l"></i></div>',
			nextArrow:
			'<div class="home-columns-carousel__nav home-columns-carousel__nav--next"><i class="icon icon--right-l"></i></div>'
		});
	}

    if (mobile) {
        if (winWidth < theme.mobileBrkp) {
			initCarousel($carousel);
		} else {
			//check if slick is initiated
			if ($carousel.hasClass("slick-initialized")) {
				//detach slick
				$carousel.slick("unslick");
			}
		}
	}
};

theme.columnsCarouselInit = function(carouselElement) {
	// if (!$(carouselElement).hasClass("slick-initialized")) {
		theme.columnsCarouselUpdate(carouselElement);

		$(window).on('resize', function() {
			theme.columnsCarouselUpdate(carouselElement);
		});
	// }
};

theme.columnsCarousel = function() {
	var carousels = $(".js-home-columns-carousel");

	var columnsCarouselObserver = generateFireOnViewObserver(theme.columnsCarouselInit);

	carousels.each(function() {
		var carousel = this;
		if (columnsCarouselObserver && !Shopify.designMode) {
			columnsCarouselObserver.observe(carousel);
		} else {
			theme.columnsCarouselInit(carousel);
		}
	});
};

theme.productAccordion = () => {

    const labels = document.querySelectorAll('.js-accordion-content');
    const tabs = document.querySelectorAll('.js-accordion-tab');

    function toggleShow() {
        const target = this;
        const item = target.classList.contains("accordion__tab")
            ? target
            : target.parentElement;
        const group = item.dataset.actabGroup;
        const id = item.dataset.actabId;

        tabs.forEach(function(tab) {
            if (tab.dataset.actabGroup === group) {
                if (tab.dataset.actabId === id) {
                    tab.classList.add("accordion__tab--active");
                } else {
                    tab.classList.remove("accordion__tab--active");
                }
            }
        });

        labels.forEach(function(label) {
            const tabItem = label.parentElement;

            if (tabItem.dataset.actabGroup === group) {
                if (tabItem.dataset.actabId === id) {
                    tabItem.classList.add("accordion__item--active");
                } else {
                    tabItem.classList.remove("accordion__item--active");
                }
            }
        });
    }

    tabs.forEach(function(tab) {
        tab.addEventListener("click", toggleShow);
    });
}

theme.getInnerHeight = () => {

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

theme.initInnerHeight = () => {

    theme.getInnerHeight();

    $(window).on('resize', () => theme.getInnerHeight());
};

theme.columnsCarousel();
theme.productAccordion();
theme.initInnerHeight();
